import { geometricBackgroundGetters } from '@/store/modules/geometricBackground/routines'

export default {
  [geometricBackgroundGetters.COMPONENT_SIZE_ROUTINE]: state => state.componentSize
}
